import { Button, Image, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMovementTabs extends Layout {
    buttonLeftNav: Button;
    buttonRightNav: Button;
    imageStatus: Image;
    imageTo: Image;
    imageYSplit: Image;
    labelEmptyMoveCount: Label;
    labelFirstCityState: Label;
    labelLastCityState: Label;
    labelMovementType: Label;
    labelOrderNumber: Label;
    labelTabTopper: Label;
    panelBorder: Panel;
    panelEmptyMovesCount: Panel;
    panelLeftNav: Panel;
    panelMovementTab: Panel;
    panelMovementTabInfo: Panel;
    panelMovementTabs: Panel;
    panelRightNav: Panel;
    panelTabInfo: Panel;
    panelTabTopper: Panel;
    textboxOrderNumber: Textbox;
}
